module.exports = __webpack_public_path__ + "media/audio79.3579d3d3.mp3";